export enum StatusVendaEnum {
  PENDING = 1,
  PAID,
  REFUSED,
  CANCELED,
  CHARGEBACK,
  REFUND,
  FAILED,
}

export const StatusVendaDescricao: {
  [key in StatusVendaEnum]: string;
} = {
  [StatusVendaEnum.PENDING]: 'Pendente',
  [StatusVendaEnum.PAID]: 'Paga',
  [StatusVendaEnum.REFUSED]: 'Recusada',
  [StatusVendaEnum.CANCELED]: 'Cancelada',
  [StatusVendaEnum.CHARGEBACK]: 'Chargeback',
  [StatusVendaEnum.REFUND]: 'Reembolso',
  [StatusVendaEnum.FAILED]: 'Falha',
};
